<template>
  <nav>
    <ul>
      <template v-if="strapiStore.navigation && strapiStore.navigation.length">
        <li v-for="(link, index) in strapiStore.navigation" :key="index" >
    
          <IO :delay="index * 0.05">
            <a v-if="link.isExternal && link.url" :href="link.url" target="_blank" rel="noopener">{{ link.text }}</a>
            <router-link 
              v-else-if="link.url && isValidUrl(link.url)" 
              :to="link.url"
              :class="{ 'custom-active': isNewsActive(link.url) }"
            >
              {{ link.text }}
            </router-link>
            <span v-else class="nav-link-disabled">{{ link.text || 'Invalid Link' }}</span>
          </IO>
        </li>
      </template>
      <template v-else-if="strapiStore.loading.navigation">
        <li>Loading navigation...</li>
      </template>
    </ul>
  </nav>
</template>

<script setup>
import { useStrapiStore } from '../stores/strapi'
import { useRoute } from 'vue-router'
import { onMounted } from 'vue'
import IO from './IO.vue'

// Get the stores and route
const strapiStore = useStrapiStore()
const route = useRoute()

// Function to validate URL
const isValidUrl = (url) => {
  if (!url || typeof url !== 'string') return false
  const trimmedUrl = url.trim()
  return trimmedUrl && trimmedUrl !== 'undefined' && trimmedUrl !== 'null' && trimmedUrl.length > 0
}

// Function to check if news should be active
const isNewsActive = (linkUrl) => {
  if (!linkUrl || linkUrl !== '/news') return false
  return route.path.startsWith('/news')
}

// Initialize data if needed
onMounted(async () => {
  if (!strapiStore.navigationData) {
    await strapiStore.fetchNavigation()
  }
})
</script>

<style lang="scss" scoped>
  @use '../assets/scss/variables' as *;
  @use '../assets/scss/templates' as *;
  @use '../assets/scss/typography' as *;

  nav{
    text-align: center;
    align-items: center;
  }

  nav ul {
    display: flex;
    list-style: none;
    gap: 90px;

    margin-left: auto; 
    margin-right: auto;
    justify-content: space-between;

    a {
      @extend %navigation-link;
      
      &.custom-active {
        color: var(--theme-link-active);
        border-bottom: 3px var(--theme-link-active) solid;
      }
      &::before {
        content: "";
        position: absolute;
        width: 80px;
        height: 80px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-image: radial-gradient(
          circle,
          #ffffff 0%,
          transparent 70%
        );
        opacity: 0;
        transition: opacity 0.25s ease, transform 0.25s ease;
        z-index: -1;
        pointer-events: none; // so it never blocks the link
      }

      &:hover::before {
        opacity: 0.1;
      }

      &:hover::active {
        opacity: 0.3;
        transform: scale(3);
      }


      
    }
    
    .nav-link-disabled {
      @extend %navigation-link;
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
</style>